<template>

    <div class="w-full">
        <h4 class="mb-3">Resellers</h4>

        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addResellerPrompt = true">Add</vs-button>

        <vx-card id="resellersDiv"  class="vs-con-loading__container">

            <vs-table ref="table" @selected="openReseller" :data="tableData" class="mt-3" pagination search :maxItems="itemsPerPage">
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="username">Username</vs-th>
                    <vs-th sort-key="email">Email</vs-th>
                    <vs-th sort-key="client_limit">Clients</vs-th>
                    <vs-th sort-key="default_user_connections">Default user connections</vs-th>
                    <vs-th sort-key="additional_connection_credit">Additional connection credits</vs-th>
                    <vs-th sort-key="credits">Credits</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].username">
                            {{ data[index].username }}
                        </vs-td>

                        <vs-td :data="data[index].email">
                            {{ data[index].email }}
                        </vs-td>

                        <vs-td :data="data[index].client_limit">
                            {{ data[index].total_clients }} / {{ data[index].client_limit }}
                        </vs-td>

                        <vs-td :data="data[index].default_user_connections">
                            {{ data[index].default_user_connections }}
                        </vs-td>

                        <vs-td :data="data[index].additional_connection_credit">
                            {{ data[index].additional_connection_credit }}
                        </vs-td>

                        <vs-td :data="data[index].credits">
                            {{ data[index].credits }}
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>

        <vs-popup title="Add reseller" :active.sync="addResellerPrompt">
            <div id="addResellerDiv" class="vs-con-loading__container" >
                <p class="mt-6">Email</p>
                <vs-input v-model="addObject['email']" class="w-full"></vs-input>
                <p class="mt-6">Username</p>
                <vs-input v-model="addObject['username']" class="w-full"></vs-input>
                <p class="mt-6">Password</p>
                <vs-input type="password" v-model="addObject['password']" class="w-full"></vs-input>
                <p class="mt-6">Client limit (0 for unlimited)</p>
                <vs-input v-model="addObject['client_limit']" class="w-full"></vs-input>
                <p class="mt-6">Default user connections</p>
                <vs-input v-model="addObject['default_user_connections']" class="w-full"></vs-input>
                <p class="mt-6">Additional connection credits</p>
                <vs-input v-model="addObject['additional_connection_credit']" class="w-full"></vs-input>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addReseller">Add</vs-button>
            </div>
        </vs-popup>

    </div>

</template>
<script>

    export default {

        data() {
            return {

                itemsPerPage: 20,
                isMounted: false,

                resellers: [],

                addResellerPrompt: false,

                addObject: {

                }

            }
        },
        methods: {

            loadData() {
                this.$vs.loading({
                    container: '#resellersDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this
                const loadPromise = this.$http.get('/api/management/v1/reseller/')
                loadPromise.then(function(response) {
                    thisIns.resellers = response.data
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#resellersDiv > .con-vs-loading')
                })
            },
            addReseller() {
                this.$vs.loading({
                    container: '#addResellerDiv',
                    type: 'corners',
                    scale: 0.7
                })

                const thisIns = this

                const addPromise = this.$http.post('/api/management/v1/reseller/', {
                    email: this.addObject.email,
                    username: this.addObject.username,
                    password: this.addObject.password,
                    client_limit: Number(this.addObject.client_limit),
                    default_user_connections: Number(this.addObject.default_user_connections),
                    additional_connection_credit: Number(this.addObject.additional_connection_credit)
                })

                addPromise.then(function(response) {
                    thisIns.addResellerPrompt = false
                    thisIns.$printSuccess('Reseller added')
                    thisIns.$nextTick(() => {
                        thisIns.$router.push('/reseller/' + response.data.id)
                    })
                }).catch(function(error) {
                    thisIns.$printError(error.response.data)
                }).finally(function() {
                    thisIns.$vs.loading.close('#addResellerDiv > .con-vs-loading')
                })
            },
            openReseller(tr) {
                this.$router.push('/reseller/' + tr.id)
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableItems() {
                if (this.isMounted) {
                    return this.$refs.table.queriedResults.length
                }
                return 0
            },
            tableData() {
                return this.resellers
            }
        },
        mounted() {
            this.isMounted = true
            this.loadData()
        }

    }

</script>
